import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { ButtonProps } from "@mui/material";
import { AppButton } from "../../../../shared/components/AppButton";
import { ClearIcon } from "../../../../shared/icons/ClearIcon";
import { EraserIcon } from "../../../../shared/icons/EraserIcon";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import styles from "./styles.module.css";

interface Props extends ButtonProps {
  iconType: "eraser" | "broom";
  typeBtn: "icon_btn" | "text_btn";
  btnVariant?: "outlined" | "contained" | "text";
  isDisabled?: boolean;
  className?: string;
}

export const ClearButton = ({
  isDisabled,
  typeBtn,
  iconType = "broom",
  btnVariant,
  className,
  ...props
}: Props) => {
  const { t } = useTranslation();

  const cls = classNames(
    styles.clear,
    {
      [styles.disabled]: isDisabled,
    },
    className,
  );

  const icon = iconType === "broom" ? <ClearIcon /> : <EraserIcon />;

  if (typeBtn === "icon_btn") {
    return (
      <AppIconButton
        disabled={isDisabled}
        buttonType={btnVariant}
        className={cls}
        {...props}
      >
        {icon}
      </AppIconButton>
    );
  }

  return (
    <AppButton
      className={cls}
      small
      buttonType={"text"}
      icon={icon}
      disabled={isDisabled}
      {...props}
    >
      {t("common.clear_btn")}
    </AppButton>
  );
};
